import { openAPIClient } from '../openApiClient';
import type {
  CreateProfileServiceConfig,
  DeleteProfileServiceConfig,
  ProfileByIdServiceConfig,
  ProfileChangelogResponse,
  ProfileChangelogServiceConfig,
  ProfileCreateResponse,
  ProfileListResponse,
  ProfileListServiceConfig,
  ProfileResponse,
  ProfileUpdateResponse,
  UpdateProfileServiceConfig,
} from './types';

export async function getProfileListService({
  httpRequestConfig,
  params,
}: ProfileListServiceConfig): Promise<ProfileListResponse> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/profile/{spaceId}', {
    params: {
      path: { spaceId: httpRequestConfig.space },
      query: params.query,
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function getProfileByIdService({
  httpRequestConfig,
  params,
}: ProfileByIdServiceConfig): Promise<ProfileResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params?.id === undefined) {
    throw new Error('Profile ID is required');
  }

  const response = await client.GET('/v1/auth/profile/{spaceId}/{id}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
        id: params.id,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function createProfileService({
  httpRequestConfig,
  params,
}: CreateProfileServiceConfig): Promise<ProfileCreateResponse> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/profile/{spaceId}', {
    params: {
      path: { spaceId: httpRequestConfig.space },
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function updateProfileService({
  httpRequestConfig,
  params,
}: UpdateProfileServiceConfig): Promise<ProfileUpdateResponse> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.PUT('/v1/auth/profile/{spaceId}/{id}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
        id: params.params.id,
      },
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function deleteProfileService({
  httpRequestConfig,
  params,
}: DeleteProfileServiceConfig): Promise<void> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.DELETE('/v1/auth/profile/{spaceId}/{id}', {
    params: {
      path: {
        spaceId: params.spaceId,
        id: params.id,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }
}

export async function getProfileChangelogService({
  httpRequestConfig,
  params,
}: ProfileChangelogServiceConfig): Promise<ProfileChangelogResponse> {
  const client = await openAPIClient(httpRequestConfig);
  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/profile/{spaceId}/{id}/changelog', {
    params: {
      path: { spaceId: httpRequestConfig.space, id: params.params.id },
      query: params.query,
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}
